import React from "react";
import { values, images } from "../mock";

const Values = () => {
  return (
    <section
      id="values"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #123c74 0%, #0e2f5c 100%)",
      }}
    >
      <div className="absolute top-0 right-0 h-72 w-72 rounded-full bg-[#5aa83a]/20 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="text-sm font-bold uppercase tracking-widest text-[#8ed06a]">
              What we stand for
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-white leading-tight">
              Our name is our promise
            </h2>
            <p className="mt-4 text-white/70 text-lg max-w-lg">
              Every letter in MVSD reflects a value we live by, in every visit,
              every conversation and every moment of care.
            </p>

            <div className="mt-10 space-y-5">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="flex items-start gap-5 group"
                >
                  <div className="h-14 w-14 shrink-0 rounded-2xl bg-white/10 group-hover:bg-[#5aa83a] flex items-center justify-center text-2xl font-extrabold text-[#8ed06a] group-hover:text-white transition-all duration-300">
                    {v.letter}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white">{v.title}</h3>
                    <p className="text-white/70 mt-1 leading-relaxed">
                      {v.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-[2rem] overflow-hidden shadow-2xl border-8 border-white/10">
              <img
                src={images.community}
                alt="Support worker with participant enjoying the outdoors"
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Values;
